<div class="main">
	<div class="container-fluid">
		<div id="commerces">
			<!-- Título y Descripción -->
			<div class="box-title">
				<h5 class="fw-bold">{{ "DCO.Title_Help" | translate }}</h5>
				<p class="text-muted">{{ "DCO.ClaimsClient_Help_PageDescription" | translate }}</p>
			</div>
			<div class="row">
				<div class="col-12 px-4">
					<!-- Navegación con estilo nav-line-tabs -->
					<ul class="nav nav-tabs nav-line-tabs mb-3 fs-6" id="helpTabs" role="tablist">
						<li class="nav-item">
							<a class="nav-link active fw-semibold" data-bs-toggle="tab" href="#tab_pane_1">
								{{ "DCO.ClaimsClient_Contact" | translate }}
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link fw-semibold" data-bs-toggle="tab" href="#tab_pane_2">
								{{ "DCO.ClaimsClient_HelpDocuments" | translate }}
							</a>
						</li>
					</ul>

					<div class="tab-content" id="myTabContent">
						<!-- PESTAÑA 1 -->
						<div class="tab-pane fade show active" id="tab_pane_1" role="tabpanel">
							<div [innerHTML]="htmlContact"></div>
						</div>

						<!-- PESTAÑA 2 -->
						<div class="tab-pane fade" id="tab_pane_2" role="tabpanel">
							<div [innerHTML]="htmlDocumentation"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>